import { render, staticRenderFns } from "./DaysComparationsCard.vue?vue&type=template&id=01a613e1&"
import script from "./DaysComparationsCard.vue?vue&type=script&lang=ts&"
export * from "./DaysComparationsCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports